/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum DocumentRequirementFulfilmentType {
  GenerateAndProvide = 'GenerateAndProvide',
  GenerateAndSign = 'GenerateAndSign',
  Gather = 'Gather',
  Provide = 'Provide',
  Accept = 'Accept',
  AttachAndSign = 'AttachAndSign'
}
